import { Component, ViewChild, ViewContainerRef, Output, ComponentFactoryResolver, OnInit, ApplicationRef, EventEmitter
} from '@angular/core';
import { TimePickerComponent } from '../time-picker/time-picker.component';
import { TimePickerConfig } from '../definitions';

// We need to import like this, because of backward compatibility of angular
/* tslint:disable */

import { Subject } from 'rxjs';
export class AtpTimePickerComponent implements OnInit {
   container: ViewContainerRef;
   timeSelected: EventEmitter<string> = new EventEmitter<string>();
public config: TimePickerConfig = {};
/**
 * @param {?} resolver
 * @param {?} appRef
 */
constructor(
private resolver: ComponentFactoryResolver,
private appRef: ApplicationRef,
  ) {}
/**
 * @return {?}
 */
ngOnInit() {
    let /** @type {?} */ config = this.config;
    config = {
      time: config.time || '00:00',
      theme: ['light', 'dark', 'material'].indexOf(config.theme) > 0 ? config.theme : 'light' || config.theme || 'light',
      rangeTime: config.rangeTime || {start: '0:0', end: '24:0'},
      arrowStyle: config.arrowStyle || {}
    };
    config.arrowStyle = {
      background: (config.arrowStyle.background) ?
      config.arrowStyle.background : config.theme !== undefined ?
      config.theme === 'dark' ? 'rgb(128, 203, 196)' : 'blue' : 'blue',
      color: config.arrowStyle.color || '#fff'
    };
    const /** @type {?} */ cfr = this.resolver.resolveComponentFactory(TimePickerComponent);
    const /** @type {?} */ tsc = this.container.createComponent(cfr);
    tsc.instance.subject = new Subject<any>();
    tsc.instance._ref = tsc;
    tsc.instance.appRef = this.appRef;
    tsc.instance.timerElement = '';
    tsc.instance.config = config;
    tsc.instance.activeModal = true;
    tsc.instance.isPopup = false;
    tsc.instance.ParseStringToTime(config.time);
    tsc.instance.subject.asObservable().subscribe(time => {
      this.timeSelected.emit(time);
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'atp-time-picker',
  template: `
    <div #container></div>
  `,
  styles: [`
    .atp-time-picker .icon-container {
      display: inline-block;
      margin-right: .2em; }
      .atp-time-picker .icon-container svg {
        cursor: pointer;
        position: relative;
        top: .5em; }
      .atp-time-picker .icon-container /deep/ i {
        cursor: pointer; }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ComponentFactoryResolver, },
{type: ApplicationRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'container': [{ type: ViewChild, args: ['container', { read: ViewContainerRef }, ] },],
'timeSelected': [{ type: Output },],
};
}

function AtpTimePickerComponent_tsickle_Closure_declarations() {
/** @type {?} */
AtpTimePickerComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AtpTimePickerComponent.ctorParameters;
/** @type {?} */
AtpTimePickerComponent.propDecorators;
/** @type {?} */
AtpTimePickerComponent.prototype.container;
/** @type {?} */
AtpTimePickerComponent.prototype.timeSelected;
/** @type {?} */
AtpTimePickerComponent.prototype.config;
/** @type {?} */
AtpTimePickerComponent.prototype.resolver;
/** @type {?} */
AtpTimePickerComponent.prototype.appRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
